import { useCallback } from "react";
import { Mail } from "lucide-react";
import { useEmailAttachmentTable } from "hooks/useEmailAttachmentTable";
import EmailAttachmentsService from "services/EmailAttachments";
import BaseTableV3 from "components/BaseTableV3/BaseTableV3";
import { TableCreateButton } from "components/BaseTableV3/TableCreateButton";
import ACL_RELATIONSHIPS from "acl-relationships";

export const EMAIL_ATTACHMENT_TABLE_CONSTANTS = {
  tableName: "email_attachments",
  queryKey: "email_attachment",
  className: "EmailAttachment",
  exportTableName: "EmailAttachmentsTable",
  header: "Email Attachments",
  headerIcon: Mail,
};

const EmailAttachmentTableV3 = () => {
  const { filters, columns } = useEmailAttachmentTable({
    className: EMAIL_ATTACHMENT_TABLE_CONSTANTS.className,
    tableName: EMAIL_ATTACHMENT_TABLE_CONSTANTS.tableName,
  });

  const fetchData = useCallback(async queryParams => {
    try {
      const response =
        await EmailAttachmentsService.getEmailAttachments(queryParams);
      return response;
    } catch (error) {
      console.error("Error fetching email attachments:", error);
      throw error;
    }
  }, []);

  const createButton = (
    <TableCreateButton
      permissions={[ACL_RELATIONSHIPS.emailAttachments.create]}
      to="/settings/email_attachments/new"
    >
      New Email Attachment
    </TableCreateButton>
  );

  return (
    <BaseTableV3
      columns={columns}
      filters={filters}
      headerIcon={EMAIL_ATTACHMENT_TABLE_CONSTANTS.headerIcon}
      header={EMAIL_ATTACHMENT_TABLE_CONSTANTS.header}
      tableName={EMAIL_ATTACHMENT_TABLE_CONSTANTS.tableName}
      queryKey={EMAIL_ATTACHMENT_TABLE_CONSTANTS.queryKey}
      className={EMAIL_ATTACHMENT_TABLE_CONSTANTS.className}
      createButton={createButton}
      fetchData={fetchData}
      enableSearch
      enableSettings
    />
  );
};

export default EmailAttachmentTableV3;
